import { Pipe, PipeTransform, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Pipe({
  name: 'adaFriendlyName',
  standalone:false
 })
export class AdaFriendlyNamePipe implements PipeTransform {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string
  ) { }
  transform(str: string, form: string): any {
    if (!str) return '';
    if (!form) return this.sanitizeText(str);

    let output = str + '';
    if (this[form]) output = this[form](this.sanitizeText(output));
    return output;
  }

  ada(str) {
    let output = str + '';
    output = this.ariaLabel(output);
    return output;
    // str = str.replace(/\s/g, '');
    // str = str.replace(/®/g, '');
    // str = str.replace(/\//g, '');
    // str = str.replace(/™/g, '');
    // str = str.replace(/℠/g, '');
    // str = str.replace(/\+/g, '');
    // str = str.replace(/&reg;/g, '');
  }

  ariaLabel(str) {
    let output = str + '';
    output = this.stripHtmlUnsafe(output);
    return output;
  }

  stripHtmlUnsafe(str) {
    if (isPlatformBrowser(this.platformId)) {
      const html = document.createElement('div');
      html.innerHTML = str;
      return html.innerText;
    }
    else {
      return str.replace(/\<.+?\>/g, '');
    }
  }

  sanitizeText(str) {
    let output = str + '';
    output = output.replace(/℠/g, '℠');
    output = output.replace(/&reg;/g, '®');
    output = output.replace(/\<br\>/g, '<br aria-hidden="true">');
    return output;
  }

  ignoreHtmlTags(str) {
    let output = str + '';
    output = output.replace(/<(sup|sub)>/g, '<$1 role="presentation">');
    return output;
  }

  sanitizePlainText(str) {
    let output = str + '';
    output = this.stripHtmlUnsafe(output);
    output = output.replace(/&reg;/g, '');
    output = output.replace(/®/g, '');
    output = output.replace(/™/g, '');
    output = output.replace(/℠/g, '');
    output = output.replace(/\+/g, '');
    output = output.replace(/&reg;/g, '');
    return output;
  }
}
